
<!------------Banner Slide Starts-->
<div id="main-wrapper-slider">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">
                <div class="constellation-wrapper">
                    <div id="particles-js"></div>
                </div>
                <img src="../../../assets/images/banners/mit-newbanner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="home banner" />

                <img src="../../../assets/images/banners/mit-newmobilebanner.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="home mobile" />
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-12 col-md-4 col-sm-6 banner-section">
                            <div
                                class="align-items-center global_title global_banner_title title_banner_content home-content">
                                <span class="text-white">Your Ideas.</span>
                            </div>
                            <div class="align-items-center global_title global_banner_title title_banner_content">
                                <span>Our Talent.</span>
                            </div>
                            <div class="align-items-center global_title global_banner_title title_banner_content">
                                <span> New Solutions.</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span>We help you build economical and sustainable solutions.</span>
                            </div>
                            <div class="front-button  col pt-lg-5 pt-3 mt-lg-2">
                                <a href="contact" class="global_button text-left col  text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="home screen button" /></div>
                                    <span> TAKE THE BIG MOVE </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
</div>
<!------------Banner Slide Ends-->
<!--====================  brand logo slider area ====================-->


<div class="brand-logo-slider-area section-space--ptb_60">
    <div class="trusted-global sixthheading text-center" >Trusted by Global Clients</div>
  
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="brand-logo-slider__container-area">
                    <swiper-container class=" brand-logo-slider__container" slides-per-view="6" autoplay="true" loop="true"  [breakpoints]="swiperBreakpoints"> 
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="swiper-wrapper brand-logo-slider__one">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/futek.png" class="img-fluid"
                                    alt="section futek ">
                            </div></div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="swiper-wrapper brand-logo-slider__one">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/apsvc-logo.png"
                                    class="img-fluid" alt="apsvclogo">
                            </div></div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/ouropinions-logo.png"
                                    class="img-fluid" alt="ouropinionslogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/sarvani-logo.png"
                                    class="img-fluid" alt="swarvanilogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/curoRC-logo.png"
                                    class="img-fluid" alt="curorclogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/newliscr-image.png"
                                    class="img-fluid" alt="liscrlogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/laqshya-logo.png"
                                    class="img-fluid" alt="laqshaylogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/new-movie-logo.png"
                                    class="img-fluid" alt="movemeasurelogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/k3ssportslogo.png"
                                    class="img-fluid" alt="k3sportslogo">
                            </div>
                        </swiper-slide>

                    </swiper-container>     
                </div>
            </div>
        </div>
    </div>
</div>





<!------------Industry Logo Ends---->

<!--======= Insights section Start =======-->
<div class="layouts-section-wrap">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 offset-sm-2 col-sm-8">
                <div class="pt-md-5" data-aos="fade-up">
                    <div class="insight-title global_section_header">
                        Insights
                        <!-- <a href=""></a> -->
                    </div>
                    <div class="insight-subtitle global_sub_title vision-content-section mt-3">
                        <span>
                            Explore insights and inspiration to unlock innovation, build trust, and engineer advantage
                            for your digital journey.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container-fluid">

        <div class="-row d-lg-none pt-lg-4">
            <div class="px-4 -col-lg-12">
                <div class="flexible-image-slider-wrap">

                    <swiper-container 
                    class="single-flexible__container " 
                    slides-per-view="1" 
                    autoplay="true" 
                    loop="true" 
                   
                    >
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider1.png" class="img img-responsive w-100 h-100 mt-2" alt="firstslider" />
                        <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>The Future of Marketing Personalization: AI-Powered Journeys</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                            <div>Across the entire customer journey, AI is assisting marketers in providing more helpful, enjoyable experiences for shoppers and improving performance. Find how retail stores can capitalize on this technology trend.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="personalize-and-machine-learning" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="insight arrow" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider2.png" class="img img-responsive w-100 h-100 mt-2" alt="secondslider" />
                        <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Embracing the next era of Digital: From Survival, Thriving to Reinvigorating</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Learn how businesses have progressed into the digital post-pandemic era and how far they can go to adapt to the changing customer mindset.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="/postpandamic" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="casestudy button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider3.png" class="img img-responsive w-100 h-100 mt-2" alt="thirdslider" />
                        <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Increase software adoption and knowledge retention while making a positive impact on the working lives of your employees.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="migrate-cloud" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                  </swiper-container>
                  
                </div>
            </div>
        </div>
      
        <div class="" >
            <app-insightsslider></app-insightsslider>
          </div>

    </div>
</div>
<!--======= Insights section Ends =======-->

<!--======= Casestudy section Starts =======-->
 <div class="casestudy-layoutsection pt-lg-5">
    <div class=" container-fluid p-0">
        <div class="row">
            <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8" data-aos="fade-up">
                <div class="casestudy_headder global_section_header my-3 mt-lg-4">Client Success Stories</div>
                <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-5">

                    Learn how we’re helping our clients take the big move with technology and the difference they make
                    across the globe.
                </div>
            </div>
        </div> 

        <!------------------Carousel section starts------>
        <!-- <div id="main-wrapper">
            <div class="site-wrapper-reveal">
                <div class="flexible-image-slider-wrapper">
                    <div class="container-fluid p-0">
                        <div class="row m-0">
                            <div class="col-lg-12 p-0">
                                <div class="flexible-image-slider-wrap ">
                                    <swiper-container  id="homeCaseStudySwiper" class=" single-flexible__container"  slides-per-view="1"  navigation="true" loop="true">
                                  

                                            <swiper-slide>
                                               
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="caseStudyStory"
                                                        src="../../../assets/images/homepage/caseStudyStory.png"
                                                        alt="casestudy button" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-down">
                                                        <div class="row supercharge">
                                                            <div class="col-12 offset-md-1 col-md-8 col-lg-8 col-xl-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100"
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">


                                                                    <div class="p-4 px-md-5 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Supercharge with Cloud and Automation</p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            FUTEK, a leading sensor technology giant
                                                                            takes the leap to cloud for a major IT
                                                                            transformation and innovation.
                                                                        </p>
                                                                        <a href="/futek-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                     
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                </swiper-slide>
                                                <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="casestudy"
                                                        src="../../../assets/images/homepage/casestudy-ouropinions-image.png"
                                                        alt="our opinions" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-up">
                                                        <div class="row supercharge">
                                                            <div
                                                                class="col-12 offset-md-1 col-md-8 col-lg-8 col-xl-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100"
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">


                                                                    <div class="p-4 px-md-5 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Helping exchange social perspectives in a
                                                                            seamless way </p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            Learn how we built a futuristic application
                                                                            and incorporated future cloud advances into
                                                                            our client’s IT infrastructure.
                                                                        </p>
                                                                        <a href="/ouropinion-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </swiper-slide>
                                    </swiper-container >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <div class="industry-button  case-study-button text-center py-3 py-md-5">
                <a href="case-studies" class="global_button">
                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                            alt="view all button" /></div> VIEW ALL
                </a>
            </div>
        </div>
    </div>
</div> -->
<!--======= Casestudy section Ends =======-->
<!--======= Casestudy section End =======-->
<div class="casestudy-layoutsection pt-lg-5">
    <div class=" container-fluid p-0">
        <!-- <div class="row">
            <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8">
                <div class="casestudy_headder global_section_header my-3 mt-lg-5">Client Success Stories</div>
                <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-5">

                    Learn how we’re helping our clients take the big move with technology and the difference they make
                    across the globe.
                </div>
            </div>
        </div> -->

        <!------------------Carousel section starts------>
        <div id="main-wrapper">
            <div class="site-wrapper-reveal">
                <div class="flexible-image-slider-wrapper">
                    <div class="container-fluid p-0">
                        <div class="row m-0">
                            <div class="col-lg-12 p-0">
                                <div class="flexible-image-slider-wrap">
                                    <swiper-container  id="homeCaseStudySwiper" class=" single-flexible__container"  slides-per-view="1"  navigation="true" loop="true">

                                            <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/caseStudyStory.png"
                                                        alt="casestudy button" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-down">
                                                        <div class="row mx-0 h-75 supercharge">
                                                            <div class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100 "
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd); height: 100% !important;">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Supercharge with Cloud and Automation</p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            FUTEK, a leading sensor technology giant
                                                                            takes the leap to cloud for a major IT
                                                                            transformation and innovation.
                                                                        </p>
                                                                        <a href="/futek-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- Single flexible slider End -->
                                                </swiper-slide>
                                                <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/casestudy-ouropinions-image.png"
                                                        alt="our opinions" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-up">
                                                        <div class="row mx-0 h-75  supercharge ">
                                                            <div
                                                                class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100"
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Helping exchange social perspectives in a
                                                                            seamless way </p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            Learn how we built a futuristic application
                                                                            and incorporated future cloud advances into
                                                                            our client’s IT infrastructure.
                                                                        </p>
                                                                        <a href="/ouropinion-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                                <!-- Single flexible slider End -->
                                            </swiper-slide>

                                     
                                    </swiper-container >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!------------------Carousel section Ends------>
            <div class="industry-button text-center py-3 py-md-5">
                <!-- <a href="case-studies" class="global_button">VIEW ALL<i class="fas fa-arrow-right"></i></a> -->
                <a href="/case-studies" class="global_button d-none d-lg-inline-block text-left col ">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow black" /></div>
                      VIEW ALL
                </a>
            </div>
        </div>
    </div>
</div>
<!--======= Casestudy section Ends =======-->

<!--======= Manufacture section starts =======-->
<section id="spotlight_section">

    <div class="pt-5" style="margin-bottom: 50px;">
        <div class="section-title global_section_header">Solution Spotlight </div>
        <div class="manufacture-subtitle global_sub_title vision-content-section text-center mt-4">
            Transform and modernize your manufacturing operations to build the agility and intelligence you need to
            thrive in the future.
        </div>
    </div>
    <div class="container-fluid">
        <div class="row w-100 m-0">
            <div class="col-md-6 col-12 p-0">

                <img class="h-100 w-100" id="spotlight_img" src="../../../assets/images/homepage/spotlight.png"
                    alt="Manufacturing Expertisee" />
            </div>
            <div class="col-md-6 col-12 p-0">

                <div class="solution_spotlight_div">
                    <div class="spotlight_content">
                        <span class="p-lg-5  p-3 manufacture_title ">MANUFACTURING IT EXPERTISE</span>
                        <div class="p-lg-5  p-3 manufacture_sub_title ">Modernizing Manufacturing one process at a Time</div>

                    </div>
                   
                    <ngx-slick-carousel class="spotlight_carousel" >

                        <div ngxSlickItem class="testimonial-slider__one wow move-up">
                            <div class="testimonial-slider--info">
                                <div class="text-center py-2 testimonial-slider__media">
                                    <img src="../../../assets/images/homepage/new-trnsform.png" width="100%"
                                        alt="transform Slider" />
                                </div>
                                <div class="testimonial-slider__author">
                                    <div class="author-info">
                                        <div class="name manufacturing-slide-name fifthheading px-3">Transformation</div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-slider__text  manufacturing-content">
                                Upgrade your enterprise with next-gen IoT and digital transformation to get ahead in
                                your industry.
                            </div>
                        </div>

                        <div ngxSlickItem class="testimonial-slider__one wow move-up">
                            <div class="testimonial-slider--info ">
                                <div class="text-center py-2">
                                    <img src="../../../assets/images/homepage/cloud.png" width="100%"
                                        alt="Cloud Computing" />
                                </div>
                                <div class="testimonial-slider__author">
                                    <div class="author-info">
                                        <div class="name manufacturing-slide-name fifthheading px-3">Cloud</div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-slider__text  manufacturing-content">
                                Leverage the combined expertise of DevOps and Cloud expertise to scale up your
                                enterprise.
                            </div>
                        </div>
                        <div ngxSlickItem class="testimonial-slider__one wow move-up">
                            <div class="testimonial-slider--info ">
                                <div class="text-center py-2">
                                    <img src="../../../assets/images/homepage/ai-image.png" width="100%"
                                        alt="AI/ML Slider" />
                                </div>
                                <div class="testimonial-slider__author">
                                    <div class="author-info">
                                        <div class="name manufacturing-slide-name fifthheading px-3">AI </div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-slider__text  manufacturing-content">
                                Automate complex tasks and provide consistent and precise optimum set points in
                                autopilot mode.
                            </div>
                        </div>
                        <div ngxSlickItem class="testimonial-slider__one wow move-up">
                            <div class="testimonial-slider--info ">
                                <div class="text-center py-2">
                                    <img src="../../../assets/images/homepage/analytics.png" width="100%"
                                        alt="Analytics Slider" />
                                </div>
                                <div class="testimonial-slider__author">
                                    <div class="author-info">
                                        <div class="name manufacturing-slide-name fifthheading px-3">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-slider__text  manufacturing-content">
                                Advanced data and analytics solutions transform data into useful insights to be on the
                                competitive edge.
                            </div>
                        </div>
                    </ngx-slick-carousel> 
                  
                </div>

            </div>

        </div>
    </div>

  
</section>
<div class="industry-button text-center mt-5 py-md-5">
    <a href="/manufacturing" class="global_button">
        <div class="dub-arrow">
            <img src="../../../assets/images/button/arrowBlack.png" alt="manufacture explore" />
        </div>
        EXPLORE
    </a>
</div>

<!--======= Manufacture section Ends =======-->

<!--------------Oracla Section starts------------>

<section>
    <div class="oracle-mainsection">
        <div class="oracle-section">
            <div class="container-fluid p-0 h-100">
                <div class="row h-100 m-0">

                    <div class="col-sm-12 p-0 col-md-3" data-aos="zoom-in" data-aos-anchor-placement="center-left">
                        <img src="../../../assets/images/banners/prasad_ceo.jpg"
                            class="img img-responsive w-100 h-100 d-md-block" width="100%" alt="prasadsir" />
                    </div>
                    <div class="col-sm-12 p-0 col-md-9" data-aos="zoom-in" data-aos-anchor-placement="center-right">
                        <div style=" background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);"
                            class="h-100">
                            <div class="row -d-flex h-100">
                                <div class="offset-1 col-11 -w-50">
                                    <div class="d-flex text_global">
                                        <div class="pt-3">
                                            <img  src="../../../assets/images/homepage/technology-cap/qoute.png" alt="quote" />

                                            <div class=" quote_title global_section_header text-white pt-2">
                                                 We believe in customer-oriented business approach with a high
                                                    quality of deliverables. With our unifying vision and team work, we
                                                    are committed in building better community and better world.
                                            </div>

                                            <div class="quote_title global_section_content text-white pt-3">
                                                <p style="font-weight: 600;">

                                                    <span>
                                                        PRASAD MAGANTI - Founder</span>

                                                </p>
                                            </div>
                                            <div class="pt-5 pb-2">
                                                <a href="/journey"
                                                    class="global_button   text-left col text-white white_button">
                                                    <div class="dub-arrow"><img
                                                            src="../../../assets/images/button/arrowWhite.png"
                                                            alt="arrow button" /></div>
                                                    GET TO KNOW US
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>

<!--------------Oracla Section ends------------>
            
<!--------------Technology Section Ends------------>
<section class="game-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="subSectionTitle global_section_header text-center">
                    Technology Capabilities
                </div>
            </div>
            <div class="row">
                <div class="col-md-1 col-sm-12"></div>
                <div class="col-md-10 col-sm-12">
                    <div class="technology-subtitle text-center global_sub_title vision-content-section mb-md-5 mt-5">
                        <span>Maganti IT combines industry knowledge with data-to-insights skills, digital
                            innovation,
                            and domain expertise to support companies in creating products and services that are
                            disruptive
                            and aligned to your business growth.
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
  
    <div class="owl-carousel custom-carousel owl-theme" data-aos="zoom-in">
        <div class="item active techItem-cloud">
            <div class="item-desc">
                <div>Cloud Computing</div>
                <p class="mt-3">Leap to the cloud and become future-ready</p>
            </div>
        </div>
        <div class="item techitem-technology" role="button">
            <div class="item-desc" >
                <div>Technology Transformation</div>
                <p class="mt-3">Co-create Business Transformation and Outperform Market Expectations
                </p>
            </div>
        </div>
        <div class="item techitem-artifical" role="button">
            <div class="item-desc">
                <div>Artificial Intelligence</div>
                <p class="mt-3">Integrate intelligent automated solutions for upgrading your business
                </p>
            </div>
        </div>
        <div class="item techitem-metaverse" role="button">
            <div class="item-desc">
                <div>Metaverse</div>
                <p class="mt-3">Wide spectrum of services across the entire Metaverse Continuum </p>
            </div>
        </div>
        <div class="item active techItem-cloud">
            <div class="item-desc">
                <div>Cloud Computing</div>
                <p class="mt-3">Leap to the cloud and become future-ready</p>
            </div>
        </div>
        <div class="item techitem-technology" role="button">
            <div class="item-desc" >
                <div>Technology Transformation</div>
                <p class="mt-3">Co-create Business Transformation and Outperform Market Expectations
                </p>
            </div>
        </div>
        <div class="item techitem-artifical" role="button">
            <div class="item-desc">
                <div>Artificial Intelligence</div>
                <p class="mt-3">Integrate intelligent automated solutions for upgrading your business
                </p>
            </div>
        </div>
        <div class="item techitem-metaverse" role="button">
            <div class="item-desc">
                <div>Metaverse</div>
                <p class="mt-3">Wide spectrum of services across the entire Metaverse Continuum </p>
            </div>
        </div>
        

</div>
</section>


<!--------------Vision Section starts------------>
<section>
    <div class="vision-section">
        <div class="container-fluid pt-5 mt-4">
            <div class="row">
                <div class="col-lg-1 col-sm-12 col-md-12">
                </div>
                <div class="col-lg-5 col-sm-12 col-md-12" data-aos="zoom-in" data-aos-anchor-placement="center-left">
                    <div class="subSectionTitle global_section_header">
                        Driven by Passion.
                    </div>
                    <div class="subSectionTitle global_section_header">
                        Powered with Vision.
                    </div>
                    <div class=" vision-content-section global_sub_title pt-5 ps-2">
                        We’re united with a common purpose- to drive impact, Uplift Experience and Unlock Growth for
                        the
                        people and Communities we serve.

                    </div>
                    <!-- <div class="vision-button  text-left col-12 pt-5">
                        <a href="#" class="global_button  text-left col ">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="arrow team" /></div>
                            JOIN OUR TEAM
                        </a>
                    </div> -->

                </div>
                <div class="col-lg-6 col-sm-12 col-md-12 visionstyle" data-aos="zoom-in"
                    data-aos-anchor-placement="center-left">
                    <div class="cubeMainDiv">
                        <div class="cubeTopFullImg">
                            <div class="position-relative h-100 w-100">
                                <a  class="navigation_cube">
                                    <div class="position-absolute h-100 overflow-hidden">
                                        <img class="h-100 w-100"
                                            src="../../../assets/images/homepage/cube/new-cubeimage.png"
                                            alt="cube internship" />
                                    </div>

                                </a>
                            </div>
                        </div>
                        <div class="cubeBottomLeftImg">
                            <div class="position-relative h-100 w-100">
                                <a href="/careers" class="navigation_cube">
                                    <div class="position-absolute h-100 overflow-hidden">
                                        <img class="h-100 w-100" src="../../../assets/images/homepage/cube/cube-1.png"
                                            alt="cube contact" />
                                    </div>
                                </a>
                            </div>

                        </div>
                        <div class="cubeBottomRightImg">

                            <div class="position-relative h-100 w-100">
                                <a href="contact" class="navigation_cube">
                                    <div class="position-absolute h-100 overflow-hidden">
                                        <img class="h-100 w-100" src="../../../assets/images/homepage/cube/cube-2.png"
                                            alt="cube team" />
                                    </div>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>




<section>
    <div class="trained">
        <div class="container-fluid">
            <div class="row">
             
            </div>
            <div class="">
                <div class="container mt-5" >
                    <div class="row" id="testimonials-logos">

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  text-center">
                            <div class="subSectionTitle global_section_header ">
                                Our Accreditations
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="swiper-slide brand-logo brand-logo--slider">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WBENC_Logo.png" class="img-fluid"
                                        alt="curorclogo">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="swiper-slide brand-logo brand-logo--slider">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WOMEN_Logo.png" class="img-fluid"
                                        alt="curorclogo">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/NMSDC_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/highly_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/A+-Rating_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 logo-container text-center">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/E-verify_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</section>

